import React, { useEffect, useState, useCallback } from 'react';
import './MobileTimeBanner.css';

function MobileTimeBanner({ activeStepId, steps, remainingTime }) {
  const [isVisible, setIsVisible] = useState(false);
  const [totalTime, setTotalTime] = useState(0);

  // Calculate total time remaining for all steps
  useEffect(() => {
    if (activeStepId && steps) {
      // Calculate remaining time for current and future steps
      const remainingSteps = steps.slice(activeStepId - 1);
      const totalRemainingTime = remainingSteps.reduce((total, step) => {
        // For current step, use remainingTime, for future steps use full duration
        return total + (step.id === activeStepId ? remainingTime : step.duration);
      }, 0);
      
      setTotalTime(totalRemainingTime);
    }
  }, [activeStepId, steps, remainingTime]);

  // Format time in hours and minutes
  const formatTimeToCompletion = (seconds) => {
    if (typeof seconds !== 'number' || seconds < 0) return '0s';
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${secs}s`;
    }
    if (minutes > 0) {
      return `${minutes}m ${secs}s`;
    }
    return `${secs}s`;
  };
  
  // Scroll handler (memoized to prevent multiple listeners)
  const handleScroll = useCallback(() => {
    const sidebar = document.getElementById('sidebar');
    const timeToBread = document.querySelector('.time-to-bread');
    
    if (sidebar) {
      // Check if either the sidebar is out of view or specifically the time-to-bread section
      const sidebarTop = sidebar.getBoundingClientRect().top;
      const sidebarBottom = sidebar.getBoundingClientRect().bottom;
      const isTimeToBreakHidden = timeToBread && 
        timeToBread.getBoundingClientRect().bottom < 0;
      
      // Show banner if sidebar is out of view or time display is hidden
      setIsVisible((sidebarTop < -20 || sidebarBottom < 0 || isTimeToBreakHidden) && activeStepId);
    }
  }, [activeStepId]);
  
  // Show banner only when scrolling past the sidebar
  useEffect(() => {
    // Run once on mount to check initial position
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    
    // Recheck visibility when activeStepId changes
    if (activeStepId) {
      handleScroll();
    }
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [handleScroll, activeStepId]);

  // If not visible or no active step, don't render
  if (!isVisible || !activeStepId) return null;

  return (
    <div className="mobile-time-banner">
      <div className="banner-content">
        <div className="banner-step">
          <strong>Step {activeStepId}</strong>/{steps.length}
        </div>
        <div className="banner-time">
          <span className="current-time">{formatTimeToCompletion(remainingTime)}</span>
          <span className="total-time">Total: {formatTimeToCompletion(totalTime)}</span>
        </div>
      </div>
    </div>
  );
}

export default MobileTimeBanner;